import React, { useContext } from 'react'
import { func, bool, string } from 'prop-types'
import { useTranslation } from 'react-i18next'

import Tooltip from 'components/Tooltip'
import Icon from 'components/uiElements/Icon'
import SugarcubeContext from 'apps/SugarcubeContext'

const FavoriteButton = ({ onClick, selected, text }) => {
    const { t } = useTranslation()
    const { isMobile } = useContext(SugarcubeContext)
    const tip = selected ? t('tooltip.remove favorite') : t('tooltip.add favorite')
    return (
        <>
            {!isMobile && <Tooltip />}
            <button
                className="FavoriteButton"
                onClick={onClick}
                data-tip={tip}
                aria-label={t('aria.favorite')}
                aria-pressed={selected ? 'true' : 'false'}
            >
                <Icon code={selected ? 'heartFilled' : 'heart'} />
                {text}
            </button>
        </>
    )
}

FavoriteButton.defaultProps = {
    text: null,
}

FavoriteButton.propTypes = {
    onClick: func.isRequired,
    selected: bool.isRequired,
    text: string,
}

export default FavoriteButton
